"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSDK2CookieUtil = void 0;
/**
 * cookie 操作类，兼容websdk 2.0(https://i.xunlei.com/login/2.5/qLogin.min.js)对cookie的操作
 */
var WebSDK2CookieUtil = /** @class */ (function () {
    /**
     *
     */
    function WebSDK2CookieUtil() {
    }
    /**
     * 获取cookies
     *
     * @param {boolean} decode
     * @return {object | string}
     */
    WebSDK2CookieUtil.prototype.getCookies = function (decode) {
        var _this = this;
        if (decode === void 0) { decode = true; }
        var cookies = this._getCurrentCookieObject(function (item) {
            if (decode && item !== undefined) {
                item = _this._decode(item);
            }
            return item;
        });
        return cookies;
    };
    /**
     * 获取cookie
     * @param {string} param
     * @param {boolean} decode
     * @return {string}
     */
    WebSDK2CookieUtil.prototype.getCookie = function (param, decode) {
        var _this = this;
        if (decode === void 0) { decode = true; }
        var cookies = this._getCurrentCookieObject(function (item) {
            if (decode && item !== undefined) {
                item = _this._decode(item);
            }
            return item;
        });
        // 取单个key
        var value = cookies[param];
        return value === undefined ? '' : value;
    };
    /**
     * 设置cookie
     * @param {string} name
     * @param {string} value
     * @param {string} domain
     * @param {number} expire
     * @param {string} path
     * @param {boolean} secure
     */
    WebSDK2CookieUtil.prototype.setCookie = function (name, value, domain, expire, path, secure) {
        var cookie;
        var expireTime = '';
        if (expire) {
            expireTime = new Date(new Date().getTime() + expire).toUTCString();
        }
        cookie = name + '=' + escape(value);
        cookie += '; path=' + (path ? path : '/');
        cookie += '; domain=' + domain;
        if (secure) {
            cookie += '; secure';
        }
        if (expire) {
            cookie += '; expires=' + expireTime;
        }
        document.cookie = cookie;
    };
    /**
     * 删除cookie
     * @param {string} name
     * @param {string} domain
     * @param {string} path
     * @param {boolean} secure
     */
    WebSDK2CookieUtil.prototype.delCookie = function (name, domain, path, secure) {
        this.setCookie(name, '', domain, -60000, path, secure);
    };
    /**
     * 动态加载资源
     * @param {string} url
     * @param  {any} opts
     * @return {Promise<void>}
     */
    WebSDK2CookieUtil.prototype.loadScript = function (url, opts) {
        if (opts === void 0) { opts = {
            type: 'text/javascript',
            language: 'javascript',
        }; }
        return new Promise(function (resolve, reject) {
            var context = document;
            var type = 'script';
            var source = context.createElement(type);
            var done = false;
            source.href = url;
            source.src = url;
            var opt = {
                type: 'text/javascript',
                language: 'javascript',
            };
            // eslint-disable-next-line guard-for-in
            for (var key in opt) {
                source[key] = opt[key];
                source.setAttribute(key, opt[key]);
            }
            // 额外属性
            // eslint-disable-next-line guard-for-in
            for (var key in opts) {
                source[key] = opts[key];
                source.setAttribute(key, opts[key]);
            }
            source.onload = source.onreadystatechange = function () {
                if (!done &&
                    (!source.readyState ||
                        source.readyState == 'loaded' ||
                        source.readyState == 'complete')) {
                    done = true;
                    resolve();
                }
            };
            context.getElementsByTagName('head')[0].appendChild(source);
        });
    };
    /**
     * 获取当前cookie对象
     * @param {Function} valueFilter
     * @return {any}
     */
    WebSDK2CookieUtil.prototype._getCurrentCookieObject = function (valueFilter) {
        var cookie = document.cookie;
        var cookieArray = cookie.split('; ');
        var obj = {};
        cookieArray.forEach(function (item) {
            var arr = item.split('=');
            var key = arr.shift();
            var value = arr.join('=');
            obj[key] = valueFilter(value);
        });
        return obj;
    };
    /**
     * decode
     * @param {string} val
     * @return {string}
     */
    WebSDK2CookieUtil.prototype._decode = function (val) {
        try {
            val = decodeURIComponent(val);
        }
        catch (e) {
            val = unescape(val);
        }
        return val;
    };
    return WebSDK2CookieUtil;
}());
exports.WebSDK2CookieUtil = WebSDK2CookieUtil;
//# sourceMappingURL=websdk2-cookie-util.js.map